import React from "react";
import { Redirect } from "@reach/router";
import { graphql } from "gatsby";

import languages from "../app/intl/languages";

const isBrowser = typeof window !== `undefined`;

const basePath =
  process.env.CI_COMMIT_REF_NAME &&
  process.env.CI_COMMIT_REF_NAME !== "production"
    ? `/${process.env.CI_COMMIT_REF_NAME}`
    : "";

export default function IndexPage({ data }) {
  const { site } = data;

  // Check SEO component that sets this property
  const preferredLanguage = isBrowser && window.localStorage.getItem("lang");

  const userLanguage =
    isBrowser &&
    ((navigator.language && navigator.language.split("-")[0]) ||
      (navigator.userLanguage && navigator.userLanguage.split("-")[0]));

  const langKey =
    preferredLanguage || userLanguage || site.siteMetadata.defaultLanguageKey;

  const path =
    (languages[langKey] && languages[langKey].baseUrl) ||
    languages[site.siteMetadata.defaultLanguageKey].baseUrl;

  return <Redirect noThrow to={basePath + path} />;
}

export const query = graphql`
  {
    site {
      siteMetadata {
        defaultLanguageKey
      }
    }
  }
`;
